import { processBigFive } from "../handlers/bigFiveHandler";

export function createDataPointProcessor(
  currentDate,
  compareDate,
  now,
  emotion,
  currentDict,
  compareDict,
  currentActionDict,
  compareActionDict,
  impactfulActions,
  filteredData,
  studentEmotionData,
  studentSupportData,
  bigFiveFilteredData,
  selectedTimes,
  selectedSubOptions,
  helpfulFilter,
  tooltipCounts,
  currentParticipants,
  compareParticipants,
  allEmotions = [],
  lineGraphSourceData = []
) {
  return (datapoint, student) => {
    let datapointTimestamp = new Date(datapoint.date).valueOf();

    if (
      datapointTimestamp >= currentDate.valueOf() &&
      datapointTimestamp <= now.valueOf()
    ) {
      currentParticipants.add(student);
      lineGraphSourceData.push(datapoint);
      currentDict[datapoint.emotion] =
        (currentDict[datapoint.emotion] || 0) + 1;

      currentActionDict[datapoint.action] =
        (currentActionDict[datapoint.action] || 0) + 1;

      // Update student support data
      if (!studentSupportData[student]) {
        studentSupportData[student] = { count: 0, total: 0, actions: {} };
      }
      studentSupportData[student].total++;
      const supportMatch =
        allEmotions &&
        allEmotions.length > 0 &&
        allEmotions.includes(datapoint.emotion);
      if (supportMatch) {
        studentSupportData[student].count++;
      }

      // Update student emotion data
      if (!studentEmotionData[student]) {
        studentEmotionData[student] = { count: 0, total: 0, actions: {} };
      }
      studentEmotionData[student].total++;
      const emotionMatch =
        datapoint.emotion === emotion || emotion === "all emotions";
      if (emotionMatch) {
        studentEmotionData[student].count++;
      }

      // Push to filtered data only once if either condition matches
      if (supportMatch || emotionMatch) {
        filteredData.push(datapoint);
      }

      // Add impactful actions
      if (emotionMatch && datapoint.helpful) {
        if (!studentEmotionData[student]["actions"][datapoint.action]) {
          studentEmotionData[student]["actions"][datapoint.action] = 0;
        }
        studentEmotionData[student]["actions"][datapoint.action] += 1;
      }

      tooltipCounts[datapoint.emotion][student] =
        (tooltipCounts[datapoint.emotion][student] || 0) + 1;
      // add 3 emotions data here as well
      impactfulActions["action"][datapoint.action] =
        (impactfulActions["action"][datapoint.action] || 0) + 1;
      impactfulActions["emotion"][datapoint.emotion] =
        (impactfulActions["emotion"][datapoint.emotion] || 0) + 1;
      processBigFive(
        selectedTimes,
        selectedSubOptions,
        helpfulFilter,
        bigFiveFilteredData,
        datapoint,
        currentDate,
        student
      );
    } else if (
      datapointTimestamp >= compareDate.valueOf() &&
      datapointTimestamp < currentDate.valueOf()
    ) {
      compareParticipants.add(student);
      compareDict[datapoint.emotion] =
        (compareDict[datapoint.emotion] || 0) + 1;
      compareActionDict[datapoint.action] =
        (compareActionDict[datapoint.action] || 0) + 1;
    }
  };
}
